const INTEGRATION_MOVEMENT = {
  TYPES: {
    INCORPORATION: 1,
    EXCLUSION: 2
  },
  STATES: {
    PENDING: 1,
    OUT_OF_TIME: 2,
    MANAGED: 3,
    NOT_CONSIDERED: 4
  }
};

export default INTEGRATION_MOVEMENT;
